import { Inject, Injectable } from "@angular/core";
import { FileOpener } from "@ionic-native/file-opener";
import { FileTransfer, FileTransferObject } from "@ionic-native/file-transfer";
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PageBuilderGlobal } from "../../../pagebuilder/providers/global";
import { AppPreferences } from "../../../shared/local/app-preferences.local";
import { LoginForms } from "../../../shared/nestjs/gd-only/dto/auth.dto";
import { ResponseChangePassDto, ResponseCheckPassDto } from "../../../shared/nestjs/gd-only/dto/sfpayslip.dto";
import { SfpayslipApi } from "../../../shared/nestjs/gd-only/services/sf-payslip.api";
import { NestApiProvider } from "../../../shared/nestjs/nest-api";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { Sf6Spt1721A1Provider } from "../../../shared/nestjs/payroll/form-1721-a-1/sf6-spt1721a1.api";
import { SfPayslipGdoProvider } from "../../../shared/nestjs/payroll/sf-payslip/sf-payslip-gdo";
import { LoopBackAuth, LoopBackConfig } from "../../../shared/sdk";
import { SfPayslipApi, SFSpt1721A1Api } from "../../../shared/sdk/services/custom";
import { AuthenticationBloc } from "../../authentication/authentication.bloc";
declare const cordova: any;

@Injectable()
export class PayslipBloc {

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private sfpayslipApi: SfpayslipApi,
    private platform: Platform,
    private transfer: FileTransfer,
    private fileOpener: FileOpener,
    private SFSpt1721A1Api: SFSpt1721A1Api,
    private nestApiProvider: NestApiProvider,
    private sfPayslipGdoProvider: SfPayslipGdoProvider,
    private sfPayslipApi: SfPayslipApi,
    private SFSpt1721A1ApiNest: Sf6Spt1721A1Provider,
    // private gdPayrollReportProvider: GdPayrollReportProvider,
    private pageBuilderGlobal: PageBuilderGlobal,
    private appPreferences: AppPreferences,
    private authenticationBloc: AuthenticationBloc,
    private nestResponsesProvider: NestResponsesProvider
  ) {

  }

  changePasswordPayslip(newPass: string, confirmPass: string, login: any): Observable<ResponseChangePassDto> {
    return this.sfpayslipApi.changePassNew({
      newpass: btoa(btoa(newPass).split("").reverse().join("")),
      confirmpass: btoa(btoa(confirmPass).split("").reverse().join("")),
      login: login
    })
  }

  checkPassword(data: any): Observable<ResponseCheckPassDto> {
    return this.sfpayslipApi.checkPass(data)
  }

  getTaxForm(param: any): Observable<any> {
    if (this.nestApiProvider.isGoPathNewExist()) {
      return this.SFSpt1721A1ApiNest.listingspt1721a1(param).pipe(
        map(res => res.data)
      );
    } else {
      return this.SFSpt1721A1Api.getTaxForm(param);
    }
  }

  getPayslip(params: any): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.sfPayslipGdoProvider.getPayslip(params)
            .pipe(
              map(res => res.data)
            )
        } else {
          return this.sfPayslipApi.getPayslip(params)
        }
      })
  }

  async getPayslipPageBuilder(empId: any): Promise<any> {
    const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
    const route = "ofid=PayslipGD.listingPayslip";
    const body = {
      empId: empId
    }
    try {
      if (isGoPathNewExist) {
        const result = await this.pageBuilderGlobal.cfcDirectApiV2(
          route,
          'POST',
          null,
          'url',
          body,
          null,
          '/builder/cfcDirect',
          true,
          false
        );
        return result.data;
      } else {
        const result = await this.pageBuilderGlobal.cfcDirectApi(route, {}, body);
        return result.data;
      }
    }
    catch (error) {
      throw error;
    }
  }

  async getDetailPayslipPageBuilder(procmtdh_id: any): Promise<any> {
    const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
    const route = "ofid=PayslipGD.payslipDetail";
    const body = {
      procmtdh_id: procmtdh_id
    }
    try {
      if (isGoPathNewExist) {
        const result = await this.pageBuilderGlobal.cfcDirectApiV2(
          route,
          'POST',
          null,
          'url',
          body,
          null,
          '/builder/cfcDirect',
          true,
          false
        );
        return result;
      } else {
        const result = await this.pageBuilderGlobal.cfcDirectApi(route, {}, body);
        return result;
      }
    }
    catch (error) {
      throw error;
    }
  }

  async validatePassword(form: LoginForms, isChangePassPayslip: boolean): Promise<any> {
    try {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      const SFGoAuth = await this.appPreferences.getAuth();
      const isSF6 = SFGoAuth.isSF6;
      let login = false;
      if (isSF6 && isGoPathNewExist && !isChangePassPayslip) {
        login = true;
        await this.checkPassword({
          // empId: SFGoAuth.empId,
          passwordCek: btoa(form.password)
        }).toPromise().catch(e => {
          if (e.error.message === 'incorrect password' || e.error.message === 'incorrect password payslip') {
            throw e.error.message;
          } else {
            login = false;
          }
        });
      }
      if (!login) {
        if (localStorage.getItem('$username') && localStorage.getItem('$username') !== 'google') {
          form.email = localStorage.getItem('$username');
        }
        return await this.authenticationBloc.loginExecute(form);
      } else {
        return login;
      }
    } catch (error) {
      if (typeof error === 'string') {
        throw error;
      } else {
        const message = this.nestResponsesProvider.handleMsgError(error);
        throw message;
      }
    }
  }

  async getCredentialPassword(form: LoginForms): Promise<{ login: any, passwordNew: any }> {
    return {
      login: await this.authenticationBloc.getPayloadLogin(form) || {},
      passwordNew: btoa(btoa(form.password).split("").reverse().join(""))
    };
  }

  async generatePDF(tax: any, data: any): Promise<void> {
    try {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      const saas = await this.appPreferences.getSaasData();
      let filenameDownload: any;
      let host = LoopBackConfig.getPath();
      let url: any;
      if (saas != null && saas != undefined) {
        if (isGoPathNewExist) {
          host = saas.storedPrelogin.GOPATHNEW;
          filenameDownload = '/' + tax.filenameDownload + '.pdf';
          url = host + '/sf6s/spt1721a1/gdDownloadPaySlipSF6?' + 'params[procytdh_id]=' + tax.procytdh_id;
        } else {
          host = saas.storedPrelogin.GOPATH;
          filenameDownload = '/' + tax.filename + '.pdf';
          url = host + '/api/SFSpt1721A1s/createpdf?filter=' + encodeURIComponent(JSON.stringify(data));
        }
        if (this.platform.is('cordova')) {
          const fileTransfer: FileTransferObject = this.transfer.create();
          const localPath = this.platform.is('android')
            ? cordova.file.externalCacheDirectory + filenameDownload
            : cordova.file.cacheDirectory + filenameDownload;
          const entry = await fileTransfer.download(url, localPath);
          return this.fileOpener.open(entry.toURL(), 'application/pdf');
        } else {
          if (isGoPathNewExist) {
            // await this.gdPayrollReportProvider.gdDownloadSPTSF6(tax);
          } else {
            window.location.href = url;
          }
        }
      }
    } catch (error) {
      throw error;
    }

  }

  async downloadPayslipSF6(procmtdh_id: any, data?: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
        let url = '';
        if (isGoPathNewExist) {
          url = this.nestApiProvider.payrollHost + '/sfPayslip/getPaySlipSF6?' + 'params[procmtdh_id]=' + procmtdh_id;
        }
        else {
          url = LoopBackConfig.getPath() + '/api/sfPayslip/createpdf?';
          url += '&filter=' + encodeURIComponent(JSON.stringify(data));
        }

        if (this.platform.is('cordova')) {
          const fileTransfer: FileTransferObject = this.transfer.create();
          const localPath = this.platform.is('android') ? cordova.file.externalCacheDirectory + '/PayslipReport.pdf' : cordova.file.cacheDirectory + '/PayslipReport.pdf';

          fileTransfer.download(url, localPath)
            .then(async (entry) => {
              await this.fileOpener.open(entry.toURL(), 'application/pdf');
              resolve(true);
            }, (error) => {
              console.log(error);
              return false;
            });
        } else {
          if (isGoPathNewExist) {
            // await this.gdPayrollReportProvider.gdDownloadPaySlipSF6(procmtdh_id);
          }
          else {
            window.location.href = url;
          }

          resolve(true);
        }
      }
      catch (error) {
        reject(error);
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/bloc/hr/payroll/payslip.bloc.ts